app.views.affordability = app.views.base.extend({
  checked: new Array(),
  unchecked: new Array(),
  constants: {
    advancedOutgoings: 'AffordabilityHouseholdOutgoingsForm',
    advancedIncome: 'AffordabilityIncomeForm',
    advancedOtherDebts: 'AffordabilityOtherDebts',
    affordabilityIncomeForm: 'AffordabilityIncomeForm',
    affordabilityDisposableIncomeForm: 'AffordabilityDisposableIncomeForm',
    affordabilityDebtOwedForm: 'AffordabilityDebtOwedForm'
  },
  childEvents: {
    'change [data-amount]': '_onChangeAmountEventHandler',
    'click [data-save-affordability]': 'onSaveAffordability',
    'click [data-input-clear]': 'onClearInput',
    'click [data-income-toggle]': '_onShowPartnerIncome',
    'click [data-arrears-toggle]': '_onShowArrears',
    'click [data-otherdebts-toggle]': '_onShowOtherDebts',
    'change [data-debt-amount]': '_onCheckDebtBalance',
    'click [data-confirm-savings]': '_onConfirmSavings',
    'click [data-add]': 'onAmendAdditionalOutgoings',
    'change [data-monthly-pra]': '_onChangePRAMonthlyAmount',
    'change [data-monthly-other]': '_onChangeOtherMonthlyAmount',
    'click [data-show-pra-remove]': '_onRemoveOtherDebtsPraRow',
    'click [data-show-other-remove]': '_onRemoveOtherDebtsOtherRow',
    'click [data-reset-income]': '_onResetIncomeFormFields',
    'click [data-reset-outgoings]': '_onResetOutgoingsFormFields',
    'click [data-reset-arrears]': '_onResetArrearsFormFields',
    'click [data-reset-other-debts]': '_onResetOtherDebtsFormFields',
    'click [data-cancel]': '_OnCancelForm',
    'change [data-advanced-amount]': 'checkPrepopulated',
    'click [data-hide-header]': '_hideAffordabilityHeader',
    'click [data-show-header]': '_showAffordabilityHeader',
    'keypress [data-input-action]': 'onInputFieldSubmit'
  },
  attr: {
    spinner: 'data-form-spinner',
    modalClose: 'data-modal-close',
    amountField: 'data-amount',
    incomeField: 'data-income',
    action: 'data-action',
    validationSummary: 'data-valmsg-summary',
    partnerIncome: 'data-partner-income',
    partnerIncomeConfirmed: 'data-income-toggle',
    adultIncome: 'data-total-group',
    incomeTotal: 'data-income-total',
    otherDebts: 'data-other-debtors',
    adjustedIncome: 'data-adultincome-total',
    otherDebtsConfirmed: 'data-otherdebts-toggle',
    otherDebtsMonthlyAmount: 'data-monthly-other',
    otherDebtsGroupTotal: 'data-debts-grouptotal',
    otherDebtsBalancecheck: 'data-balance-check',
    otherDebtsBalance: 'data-debt-balance',
    otherDebtsAmount: 'data-debt-amount',
    outgoingItems: 'data-item',
    defaultOutgoingFields: 'data-default-container',
    outgoingChecked: 'data-checked',
    outgoingContainer: 'data-container',
    arrearsConfirmed: 'data-arrears-toggle',
    arrearsVisible: 'data-arrears',
    optionalOutgoingItem: 'data-outgoing-item',
    outgoingsButton: 'data-outgoings',
    outgoingsTotal: 'data-outgoings-total',
    addOutGoing: 'data-add',
    savingsConfirmed: 'data-confirmsavings-toggle',
    savingsChanged: 'data-savings-confirmation',
    addPRAButton: 'data-show-pra-add',
    addOtherButton: 'data-show-other-add',
    removePRAButton: 'data-show-pra-remove',
    removeOtherButton: 'data-show-other-remove',
    incomeForm: 'data-income',
    outgoingsForm: 'data-outgoings',
    arrearsForm: 'data-arrears',
    arrearsTotal: 'data-arrears-total',
    otherDebtsForm: 'data-debts',
    subTotal: 'data-total',
    grandTotal: 'data-total-grand',
    otherHideableDebt: 'data-other-hideable',
    praHideableDebt: 'data-pra-hideable',
    debtHideableRow: 'data-hideable-row',
    groupInput: 'data-debts-input',
    adjustedDebt: 'data-debts-total',
    inputClear: 'data-input-clear',
    currencyAmount: 'data-currency-amount',
    inputSubmit: 'data-input-action',
    debtInputValue: 'data-debts-group',
    otherCreditorName: 'data-creditor-name'
  },
  classes: {
    header: 'header',
    footer: 'footer',
    hidden: 'hidden',
    affordabilityHeader: 'affordability-header',
    inputValidationError: 'input-validation-error'
  },
  init: function init() {
    this._hideOriginalHeader();
    this._initCurrencyFormat();
    this.checkPrepopulated();
    this.onActionButtonPress();
    this._setButtonCaption();
  },
  /**
   * On Begin Progression Event
   * Fires on the start of changing an affordability step.
   * @public
   */

  onBeginProgressionEvent: function onBeginProgressionEvent() {
    $('[' + this.attr.spinner + ']').show();
  },
  /**
   * On Progression Event
   * Listens for a affordability step change.
   * @public
   * @param {data} response : the response from the controller.
   */

  onProgressionEvent: function onProgressionEvent(response) {
    if (response && response.nextRequestAjax === false) {
      window.location = window.location.origin + response.redirectUrl;
    } else {
      $('[' + this.attr.spinner + ']').hide();
    }
  },
  _setButtonCaption: function _setButtonCaption() {
    var formId = $('form').prop('id');
    _this = this;
    if (formId == _this.constants.affordabilityIncomeForm || formId == _this.constants.affordabilityDisposableIncomeForm || formId == _this.constants.affordabilityDebtOwedForm) {
      $('#AffordabilityRestoreSavedButton').show();
      $('#AffordabilitySavedButton').hide();
    } else {
      $('#AffordabilityRestoreSavedButton').hide();
      $('#AffordabilitySavedButton').show();
    }
  },
  /**
   * On Complete Progression Event
   * Fires on the completion of an affordability step change.
   * @public
   */

  onCompleteProgressionEvent: function onCompleteProgressionEvent() {
    $('[' + this.attr.validationSummary + ']').find('ul').html('');
    app.initElementListeners('#AffordabilitySteps');
    this._initOnStepProgression();
    $('html, body').animate({
      scrollTop: 0
    }, 'slow');
  },
  /**
   * Affordability Progression Event Handler
   * Handles the process for progression events on the affordability steps.
   * @public
   * @param {event} e : Action event
   * @param {data} progression : The state which decides how to proceed
   */
  onAffordabilityPreviousEventHandler: function onAffordabilityPreviousEventHandler(e) {
    var form = $(e.currentTarget).parents('form');
    var container = $('#AffordabilitySteps');
    e.preventDefault();
    $('[' + this.attr.spinner + ']').show();
    if (form === null || form === undefined) {
      console.error('No form found on page - unable to proceed to previous step');
      return;
    }
    if (container === null || container === undefined) {
      console.error('No element found to update - unable to proceed to previous step');
      return;
    }
    $.ajax({
      url: form.action,
      method: 'POST',
      data: $(form).serialize() + '&progression=previous',
      success: function success(response) {
        $(container).html(response);
        app.initElementListeners(container);
      }
    });
  },
  /**
   * Iterate modal checkboxes
   * Checks if modal checkbox ids are present in the checked array and if so sets them to checked
   * If any ids are not present in the checked array, they are added to the unchecked array
   * @public
   */

  modalCheckboxIterator: function modalCheckboxIterator() {
    var _this = this;
    var unchecked = [];
    $('[' + this.attr.outgoingItems + ']').each(function (index, value) {
      var checkbox = $(this);
      var value = checkbox.attr(_this.attr.outgoingItems);
      var checkedCount = $('[' + _this.attr.outgoingItems + ']:checkbox:checked').length;
      var checkedAdjusted = checkedCount + 1;
      if (jQuery.inArray(value, _this.checked) != -1) {
        checkbox.prop('checked', true);
        $('[' + _this.attr.addOutGoing + ']').html("Amend " + "(" + checkedAdjusted + ")");
      } else {
        unchecked.push(value);
        checkbox.prop('checked', false);
      }
    });
    this.unchecked = unchecked;
  },
  /**
    * Check status of modal checkboxes
    * Checks if modal checkbox are checked or unchecked, and updates the selected number in the "Add selected" button
    * If checked, id is added to checked array and removed from unchecked, and vice versa for unchecked
    * @public
    */

  modalCheckboxSelect: function modalCheckboxSelect() {
    var _this = this;
    var checked = this.checked;
    var unchecked = this.unchecked;
    $('[' + this.attr.outgoingItems + ']').change(function (index, value) {
      var checkbox = $(this);
      var value = checkbox.attr(_this.attr.outgoingItems);
      if (checkbox.prop('checked') == true) {
        checked.push(value);
        var _index = unchecked.indexOf(value);
        if (_index > -1) {
          unchecked.splice(_index, 1);
        }
      } else if (checkbox.prop('checked') == false) {
        unchecked.push(value);
        var _index2 = checked.indexOf(value);
        if (_index2 > -1) {
          checked.splice(_index2, 1);
        }
      }
      var checkedCount = $('[' + _this.attr.outgoingItems + ']:checkbox:checked').length;
      $('[' + _this.attr.addOutGoing + ']').html("Amend " + "(" + checkedCount + ")");
    });
  },
  /**
   * Adds selected outgoings
   * Checks if item is in checked array, and if so sets its visibility to show; otherwise it is hidden
   * Striping is re-applied to the list of visible outgoings after update to ensure consistency
   * @public
   */

  onAmendAdditionalOutgoings: function onAmendAdditionalOutgoings() {
    var _this = this;
    var checked = this.checked;
    $('[' + this.attr.outgoingItems + ']').each(function (index, value) {
      var item = $(this);
      var value = item.attr(_this.attr.outgoingItems);
      var element = $('[' + _this.attr.optionalOutgoingItem + '="' + value + '"]');
      if (item.prop('checked') == true && checked.includes(value)) {
        element.show();
        element.attr(_this.attr.outgoingChecked, value);
      } else {
        element.hide();
        element.removeAttr(_this.attr.outgoingChecked);
        element.find('input[data-amount]').val('');
      }
      $(".row:visible").each(function (index) {
        $(this).css("background-color", !!(index & 1) ? "#F0F1F1" : "#FFFFFF");
      });
    });
    var outgoingsTotal = 0;
    $('[' + this.attr.amountField + ']').each(function () {
      var value = $(this).val().replace(',', '');
      if (value) {
        outgoingsTotal = outgoingsTotal + parseFloat(value);
      }
    });
    $('body').find('[' + this.attr.outgoingsTotal + ']').html("Apply Outgoings: £" + $.number(outgoingsTotal, 2));
    $.magnificPopup.instance.close();
  },
  /**
  * Save Progress Button
  * Listens for the Save button being pressed on header
  * Submits current page and stores progress returning a code to reload.
  * @public
  */
  onSaveAffordability: function onSaveAffordability() {
    var toSave = $('form').append('<input type="hidden" name="progression" value="save" />');
    toSave.submit();
  },
  /**
  * Save Progress
  * When progress is saved this pops the modal containing restore code
  * @private
  */

  openSaveModal: function openSaveModal() {
    var _this = this;
    $.magnificPopup.open({
      items: {
        src: window.location.origin + '/affordability/save-modal',
        type: 'ajax'
      },
      callbacks: {
        open: function open() {
          $.magnificPopup.instance.wrap[0].addEventListener('focus', function () {
            app.initElementListeners($('.' + _this.classes.modal));
            $('[' + _this.attr.modalClose + ']').on('click', function () {
              $.magnificPopup.close();
            });
          });
        }
      }
    });
  },
  /**
   * Amount Change Event Hanlder
   * Listens for the amount field being changed.
   * Disables or enables the form action beased on the field value.
   * @private
   * @param {event} e : Action event
   */
  _onChangeAmountEventHandler: function _onChangeAmountEventHandler(e) {
    var input = $(e.currentTarget);
    var action = $('[' + this.attr.action + ']');
    var amount = parseFloat(input.val());
    if (amount > 0) {
      action.prop('disabled', false);
      action.removeClass('disabled');
      $('[' + this.attr.inputClear + ']').show();
    } else {
      action.prop('disabled', true);
      action.addClass('disabled');
      $('[' + this.attr.inputClear + ']').hide();
    }
  },
  /**
  * Initalises Autonumeric on input fields
  * Listens for the amount field being changed and formats
  * @private
  */

  _initCurrencyFormat: function _initCurrencyFormat() {
    $('body').find('[' + this.attr.currencyAmount + ']').each(function () {
      new AutoNumeric(this, {
        watchExternalChanges: true,
        minimumValue: 0
      });
    });
  },
  /**
  * Hide original header
  * Hides standard header and allows for affordability header with additional buttons to load
  * @private
  */

  _hideOriginalHeader: function _hideOriginalHeader() {
    $('.' + this.classes.header).hide(); // TODO: Hide first
    $('.' + this.classes.navigation).hide();
    $('.' + this.classes.actions).hide();
    $('.' + this.classes.header).remove();
    $('.' + this.classes.navigation).remove();
    $('.' + this.classes.actions).remove();
  },
  /**
  * Hide affordability header
  * Hides affordability header when loading advanced forms
  * @private
  */

  _hideAffordabilityHeader: function _hideAffordabilityHeader() {
    $('.' + this.classes.affordabilityHeader).hide();
    $('.' + this.classes.footer).hide();
  },
  /**
  * Re-show affordability header
  * Reshows affordability header when moving away from advanced froms
  * @private
  */

  _showAffordabilityHeader: function _showAffordabilityHeader() {
    $('.' + this.classes.affordabilityHeader).show();
    $('.' + this.classes.affordabilityHeader).removeAttr('header--fixed');
    $('.' + this.classes.footer).show();
  },
  /**
  * Clears Inputs
  * Listens for clear icon on input fileds to be clicked to clear input
  * @public
  */
  onClearInput: function onClearInput() {
    $('[' + this.attr.amountField + ']').val("");
    $('[' + this.attr.inputClear + ']').hide();
    $('[' + _this.attr.action + ']').prop('disabled', true);
    $('[' + _this.attr.action + ']').addClass('disabled');
  },
  /**
   * On Show Partner Event
   * Listens for the additional income checkbox being changed.
   * Shows or hides the additional income section (adult 2) of the Household income modal
   * @private
   */

  _onShowPartnerIncome: function _onShowPartnerIncome() {
    var adjustedIncome = $('[' + this.attr.adjustedIncome + ']');
    var adult1Debt = $('[' + this.attr.subTotal + '="' + "adult1" + '"]').html();
    var adultIncomeText = 'Apply Income: £';
    if ($('[' + this.attr.partnerIncomeConfirmed + ']').is(':checked')) {
      $('[' + this.attr.partnerIncome + ']').show();
    } else {
      $('[' + this.attr.partnerIncome + ']').hide();
      $('[' + this.attr.adultIncome + '="' + "adult2" + '"]').val("");
      $('[' + this.attr.subTotal + '="' + "adult2" + '"]').html("0.00");
      $('[' + this.attr.subTotal + '="' + "adult2" + '"]').val("");
      adjustedIncome.html(adultIncomeText + adult1Debt);
    }
  },
  /**
  * On confirm savings Event
  * Listens for the outgoings submit button being clicked and whether the confirmation of savings box has been checked.
  * If the checkbox is not checked on submit a warning message is displayed and the submit button is disabled
  * @private
  */
  _onConfirmSavings: function _onConfirmSavings(e) {
    if ($('[' + this.attr.savingsConfirmed + ']').prop('checked') == false) {
      e.preventDefault();
      var position = $("#Confirm").offset().top;
      $('html, body').animate({
        scrollTop: position
      }, 'slow');
      $('[' + this.attr.savingsChanged + ']').addClass('warning');
    } else {
      if ($('[' + this.attr.arrearsConfirmed + ']').prop('checked') == false) {
        this._showAffordabilityHeader();
      }
    }
  },
  /**
  * On show Arrears Event
  * Listens for the outgoings arrears box being checked.
  * When clicked, diverts the flow to the arrears page when the outgoings submit button is clicked
  * @private
  */

  _onShowArrears: function _onShowArrears() {
    if ($('[' + this.attr.arrearsConfirmed + ']').is(':checked')) {
      var arrearsStep = 9;
      $('[' + this.attr.outgoingsButton + ']').val(arrearsStep);
    } else {
      var otherDebtStep = 5;
      $('[' + this.attr.outgoingsButton + ']').val(otherDebtStep);
    }
  },
  /**
  * Initialize On Step Progression
  * Fires when the 'On Complete Progression Event' is executed.
  * @private
  */

  _initOnStepProgression: function _initOnStepProgression() {
    this._initCurrencyFormat();
    this.checkPrepopulated();
    this._showPopulatedFields();
    this._setButtonCaption();
    this._onShowArrears();
    this._onShowPartnerIncome();
  },
  /**
   * On show other debtors Event
   * Listens for the outstanding debts with other creditors checkbox being changed.
   * Shows or hides section for other creditors on the other debts page
   * If changed from show to hide, the monthly field values are reset, and visible rows are hidden
   * @private
   */

  _onShowOtherDebts: function _onShowOtherDebts() {
    var otherDebtsHideable = $('[' + this.attr.otherHideableDebt + ']');
    var adjustedDebt = $('[' + this.attr.adjustedDebt + ']');
    var praDebt = $('[' + this.attr.subTotal + '="' + "pradebt" + '"]').html();
    var otherDebtText = 'Apply Other Debts: ';
    if ($('[' + this.attr.otherDebtsConfirmed + ']').is(':checked')) {
      $('[' + this.attr.otherDebts + ']').show();
    } else {
      $('[' + this.attr.otherDebts + ']').hide();
      $('[' + this.attr.otherDebts + ']').find('input').val('');
      $('[' + this.attr.subTotal + '="' + "otherdebt" + '"]').html("0.00");
      $('[' + this.attr.otherDebts + ']').find(otherDebtsHideable).hide();
      adjustedDebt.html(otherDebtText + praDebt);
    }
  },
  /**
    * Show Add PRA debtor button
    * Listens for a change in the PRA debtor monthly amount field and if so displays a button to add additional fields
    * @private
    */

  _onChangePRAMonthlyAmount: function _onChangePRAMonthlyAmount(e) {
    var input = $(e.currentTarget);
    var amount = parseFloat(input.val());
    if (amount > 0) {
      $('[' + this.attr.addPRAButton + ']').show();
    } else {
      $('[' + this.attr.addPRAButton + ']').hide();
    }
  },
  /**
   * Show Add Other debtor button
   * Listens for a change in the other debt amount field and if so displays a button to add additional fields
   * @private
   */

  _onChangeOtherMonthlyAmount: function _onChangeOtherMonthlyAmount(e) {
    var input = $(e.currentTarget);
    var amount = parseFloat(input.val());
    if (amount > 0) {
      $('[' + this.attr.addOtherButton + ']').show();
    } else {
      $('[' + this.attr.addOtherButton + ']').hide();
    }
  },
  /**
  * Show Add PRA debtor button
  * Listens for a click of remove to show add button
  * @private
  */

  _onRemoveOtherDebtsPraRow: function _onRemoveOtherDebtsPraRow() {
    $('[' + this.attr.addPRAButton + ']').show();
  },
  /**
  * Show Add Other debtor button
  * Listens for a click of remove to show add button
  * @private
  */

  _onRemoveOtherDebtsOtherRow: function _onRemoveOtherDebtsOtherRow() {
    $('[' + this.attr.addOtherButton + ']').show();
  },
  /**
   * Reset input amounts on all advanced forms
   * Listens for a reset button click and resets the appropriate amount input fields
   * @public
   */

  onResetFormFields: function onResetFormFields() {
    var fields = $('[' + this.attr.amountField + ']');
    if (fields) {
      fields.each(function (index) {
        $(this).val("");
      });
    }
  },
  /**
  * Resets Advanced income form
  * Listens for a reset button click and resets Apply income button total text, partner income toggle, hidden variables for adult 2.
  * Apply income button is also disabled.
  * @private
  */

  _onResetIncomeFormFields: function _onResetIncomeFormFields() {
    this.onResetFormFields();
    $('[' + this.attr.incomeTotal + ']').html("Apply Income: £0.00");
    $('[' + this.attr.incomeTotal + ']').prop('disabled', true);
    $('[' + this.attr.partnerIncome + ']').hide();
    $('[' + this.attr.partnerIncomeConfirmed + ']').prop('checked', false);
    $('[' + this.attr.subTotal + '="' + "adult2" + '"]').html("0.00");
    $('[' + this.attr.subTotal + '="' + "adult2" + '"]').val("");
  },
  /**
  * Resets Advanced outgoings form
  * Listens for a reset button click and resets Apply outgoings button total text, all toggles and checkboxes, and checked/unchecked arrays.
  * Apply outgoings button is also disabled.
  * @private
  */

  _onResetOutgoingsFormFields: function _onResetOutgoingsFormFields() {
    this.onResetFormFields();
    $('[' + this.attr.outgoingsTotal + ']').html("Apply Outgoings: £0.00");
    $('[' + this.attr.outgoingsTotal + ']').prop('disabled', true);
    $('[' + this.attr.optionalOutgoingItem + ']').hide();
    $('[' + this.attr.outgoingItems + ']').prop('checked', false);
    $('[' + this.attr.savingsConfirmed + ']').prop('checked', false);
    $('[' + this.attr.arrearsConfirmed + ']').prop('checked', false);
    this.checked = [];
    this.unchecked = [];
  },
  /**
   * Resets Advanced arrears form
   * Listens for a reset button click and resets Apply arrears button total text and all subtotals for total and monthly amounts.
   * @private
   */

  _onResetArrearsFormFields: function _onResetArrearsFormFields() {
    this.onResetFormFields();
    $('[' + this.attr.arrearsTotal + ']').html("Apply Arrears: £0.00");
    $('[' + this.attr.subTotal + '="' + "amount" + '"]').html("£0.00");
    $('[' + this.attr.subTotal + '="' + "amount" + '"]').val("");
    $('[' + this.attr.subTotal + '="' + "monthly" + '"]').html("£0.00");
    $('[' + this.attr.subTotal + '="' + "monthly" + '"]').val("");
  },
  /**
   * Resets Advanced other debts form
   * Listens for a reset button click and resets Apply other debts button total text, all hideable rows and buttons.
   * Disables the Apply other debts button.
   * @private
   */

  _onResetOtherDebtsFormFields: function _onResetOtherDebtsFormFields() {
    $('[' + this.attr.otherCreditorName + ']').val("");
    $('[' + this.attr.otherDebtsGroupTotal + ']').html("Apply Other Debts: £0.00");
    $('[' + this.attr.otherDebtsGroupTotal + ']').prop('disabled', true);
    $('[' + this.attr.addPRAButton + ']').hide();
    $('[' + this.attr.removePRAButton + ']').hide();
    $('[' + this.attr.removeOtherButton + ']').hide();
    $('[' + this.attr.otherDebts + ']').hide();
    $('[' + this.attr.debtHideableRow + ']').hide();
    $('[' + this.attr.otherDebtsConfirmed + ']').prop('checked', false);
    $('[' + this.attr.debtInputValue + '="' + "amount" + '"]').val("");
    $('[' + this.attr.debtInputValue + '="' + "payment" + '"]').val("");
  },
  /**
   * Reset sub totals and totals on advanced forms
   * Listens for a cancel button click and resets the appropriate sub/grand total values to prevent them from being added to the previous step
   * Re-shows affordability header
   * @private
   */

  _OnCancelForm: function _OnCancelForm() {
    this.onResetFormFields();
    $('[' + this.attr.subTotal + ']').val("");
    $('[' + this.attr.grandTotal + ']').val("");
    $('[' + this.attr.otherDebtsGroupTotal + ']').val("");
    $('[' + this.attr.adjustedDebt + ']').val("");
    $('[' + this.attr.otherDebtsConfirmed + ']').prop('checked', false);
    $('[' + this.attr.otherCreditorName + ']').val("");
    $('.' + this.classes.affordabilityHeader).show();
    $('.' + this.classes.footer).show();
    $('[' + this.attr.partnerIncome + ']').hide();
    $('[' + this.attr.adultIncome + '="' + "adult2" + '"]').val("");
    $('[' + this.attr.subTotal + '="' + "adult2" + '"]').html("0.00");
    $('[' + this.attr.subTotal + '="' + "adult2" + '"]').val("");
    adjustedIncome.html(adultIncomeText + adult1Debt);
    this.checked = [];
    this.unchecked = [];
  },
  /**
   * Checks for populated values from restore
   * Checks is the form has been populated from a restore and if the submit for current page should be enabled
   * @public
   */

  checkPrepopulated: function checkPrepopulated() {
    _this = this;
    $('[' + this.attr.amountField + ']').each(function () {
      if (parseFloat($(this).val()) > 0) $('[' + _this.attr.action + ']').prop('disabled', false);
      $('[' + _this.attr.action + ']').removeClass('disabled');
    });
  },
  /**
  * Checks for previously populated additional fields
  * Checks for that any optional (hidden) fields have values and shows then when moving back to the page
  * @public
  */

  _showPopulatedFields: function _showPopulatedFields() {
    var formId = $('form').prop('id');
    _this = this;
    if (formId == _this.constants.advancedOutgoings) {
      $('[' + _this.attr.optionalOutgoingItem + ']').each(function () {
        var item = this;
        if ($(item).find('input[' + _this.attr.amountField + ']').val() > 0) {
          $(this).show();
        }
      });
    }
    if (formId == _this.constants.advancedIncome) {
      $('[' + _this.attr.partnerIncome + ']').each(function () {
        if ($(this).find('input[' + _this.attr.amountField + ']').val() > 0) {
          $(this).show();
        }
      });
    }
    if (formId == _this.constants.advancedOtherDebts) {
      $('[' + _this.attr.otherHideableDebt + ']').each(function () {
        if (parseFloat($(this).find('input[data-debts-group="payment"]').val()) > 0) {
          $('[' + _this.attr.otherDebts + ']').show();
          $('[' + _this.attr.otherDebtsConfirmed + ']').prop('checked', true);
          $(this).show();
        }
      });
      var otherVisibleFieldsCount = $('[' + _this.attr.otherHideableDebt + ']').filter(":visible").length;
      if (otherVisibleFieldsCount < 5) {
        $('[' + _this.attr.addOtherButton + ']').show();
      }
      if (otherVisibleFieldsCount > 1) {
        $('[' + _this.attr.removeOtherButton + ']').show();
      }
      $('[' + _this.attr.praHideableDebt + ']').each(function () {
        if (parseFloat($(this).find('input[data-debts-group="payment"]').val()) > 0) {
          $(this).show();
        }
      });
      var praVisibleFieldsCount = $('[' + _this.attr.praHideableDebt + ']').filter(":visible").length;
      if (praVisibleFieldsCount < 4 && praVisibleFieldsCount > 1) {
        $('[' + _this.attr.addPRAButton + ']').show();
      }
      if (praVisibleFieldsCount > 1) {
        $('[' + _this.attr.removePRAButton + ']').show();
      }
    }
  },
  /**
  * Keyboard Accessiblity for action button
  * Allows enter key to perform a click event on the action button when it is in focus
  * @public
  */

  onActionButtonPress: function onActionButtonPress() {
    var action = $('[' + this.attr.action + ']');
    $(action).keydown(function (event) {
      if (event.keyCode === 13 || event.key === 'Enter') {
        action.click();
      }
    });
  },
  /**
  * Keyboard Accessiblity for form input field
  * Allows enter key to submit the form from an input field
  * @public
  */

  onInputFieldSubmit: function onInputFieldSubmit(event) {
    event.preventDefault();
    if (event.keyCode === 13 || event.key === 'Enter') {
      var inputSubmit = $('[' + this.attr.inputSubmit + ']');
      var step = inputSubmit.attr(this.attr.inputSubmit);
      var toProgress = $('form').append('<input type="hidden" name="progression" value="' + step + '" />');
      toProgress.submit();
    }
  }
});